import { HTTP_METHODS } from '@studio/constants/axios';
import { SEARCH_API_V1 } from '@studio/constants/env-variables';
import type { ClipSearch } from '@studio/types';

export const root = {
  [HTTP_METHODS.GET]: {
    url: `${SEARCH_API_V1}/clip/@customerId`,
    response: {} as ClipSearch.Get.Response,
    method: HTTP_METHODS.GET,
    paramOptions: { allowDots: true, encode: true },
    query: {} as ClipSearch.Get.Params,
  },
};

export const id = {};
